import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { FieldList, Pager } from '../../';
import moment from 'moment';

const copy = obj => (JSON.parse(JSON.stringify(obj)));

class IncidentFormNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      storm: null,
      damage_level: null,
      material_type: null,
      description: '',
      files: [],
      adjuster: null,
      client: null,
      creator: null
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitIncident = this.submitIncident.bind(this);
  }

  componentWillMount() {
    this.props.fetchRecentImpacts(this.props.client._id);
    this.props.fetchIncidents(this.props.client._id || this.props.client);

    if (this.props.entity) {
      this.setState({ ...this.props.entity, job : this.props.job, storm: this.props.entity.storm ? ({ value: this.props.entity.storm._id, label: this.props.entity.storm.properties.title }) : undefined })
    } else {
      this.setState({ client: this.props.client._id, job : this.props.job, creator: this.props.user._id });
    }
  }

  componentWillReceiveProps() {
    if (this.props.entity) {
      this.setState({ ...this.props.entity, job : this.props.job, storm: this.props.entity.storm ? ({ value: this.props.entity.storm._id, label: this.props.entity.storm.properties.title }) : undefined })
    } else {
      this.setState({ client: this.props.client._id, job : this.props.job, creator: this.props.user._id });
    }
  }

  handleChange(value, name) {
    let copy_state = copy(this.state);
    let entity = copy_state;
    let names = name.split('.');

    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {};
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState(copy_state);
  }

  submitIncident() {
    if (this.props.onSubmit) {
      return this.props.onSubmit(this.state);
    }

    this.props.sendSocketEmit(this.state, 'client-incident-new');
  }

  render() {

    const damageLevels = ['None','Light', 'Moderate', 'Severe'].map((level, idx) => {
      return { value: level, label: level }
    });

    const materialTypes = ['Asphalt', 'Composition', 'Rolled', 'Metal', 'Tile', 'Slate'].map((material, idx) => {
      return { value: material, label: material };
    });

    const impacts = this.props.client_incidents.recent_impacts;

    const stormOptions = (impacts) ?
      impacts.map((impact, idx) => {
        const storm_date = moment(impact.properties.storm_date).format('MM-DD-YYYY');
        return { value: impact._id, label: `${storm_date} - ${impact.properties.title}` };
      }) : [];

    const fields = [{
      _id: 1,
      flex: 6,
      label: 'Damage Level',
      name: 'damage_level',
      type: 'select',
      options: damageLevels,
      placeholder: 'Select Damage Level'
    }, {
      _id: 2,
      flex: 6,
      label: 'Material Type',
      name: 'material_type',
      type: 'select',
      options: materialTypes,
      placeholder: 'Select Material Type'
    }, {
      _id: 3,
      flex: 6,
      label: 'Impact Storm',
      name: 'storm',
      type: 'select',
      options: stormOptions,
      value: this.state.storm,
      placeholder: 'Select Impact Storm'
    }, {
      _id: 6,
      flex: 6,
      label: 'Incident Date',
      name: 'incident_date',
      type: 'date',
      placeholder: 'Select Impact Date',
    }, {
      _id: 4,
      flex: 6,
      label: 'Adjuster',
      name: 'adjuster',
      type: 'text',
      placeholder: 'Adjuster Name'
    }, {
      _id: 5,
      flex: 12,
      label: 'Description',
      name: 'description',
      type: 'textarea',
      rows: 6,
      placeholder: 'Description of the incident...'
    }];

    return <div>
      {(() => this.props.new ? <p className="pull-right"><strong>* Note: </strong>Additional information can be entered once a lead has been created.</p> : <noscript/>)() }
      <FieldList
        entity={(() => {
          if (this.state.storm && this.state.storm.value && !this.props.editing) {
            this.state.storm = this.state.storm.label
          }
          return this.state;
        })()}
        onChange={this.handleChange}
        fields={fields}
        readOnly={!this.props.editing}
      />
      {(() => this.props.editing ? <ul className="pager">
        <li><hr /></li>
        <li className="finish pull-right">
          <a onClick={this.submitIncident}>Finish</a>
        </li>
      </ul> : <noscript/>)()}
    </div>
  }
}

const mapStateToProps = ({ client_incidents, client, connection, jobs }) => ({ client_incidents, client, user: connection.user, job : jobs.previewing_job });

export default connect(mapStateToProps, Actions)(IncidentFormNew);



// WEBPACK FOOTER //
// ./src/browser/components/client/incidents/incident-form-new.js